module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.13d8b8dd.webp";